/*------------------------------------*\
    MODULES
\*------------------------------------*/
import DisplayToggle from './modules/display-toggle';
import Hamburger from './modules/hamburger';
import LazyLoad from './modules/lazy-load';
import SiteNav from './modules/site-nav';
import Typeset from './modules/typeset';
import mediumZoom from 'medium-zoom';

/*------------------------------------*
    APP DELEGATE
\*------------------------------------*/
const app = {

    init() {
        this.bind();

        // Remove no-js stuff
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');

        // When everything is loaded, add a class to the window
        window.addEventListener('load', () => { document.documentElement.className += ' is-window-loaded' });

        // Fire up the typesetter 
        let typsetInstance = new Typeset(document.documentElement);

        typsetInstance.init();

        // Medium zoom
        mediumZoom('[data-zoom-src]');
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if(!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if(!modules.length) {
                return false;
            }

            // Add a bound class
            item.classList.add('is-bound');

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch(module) {

                    case 'display-toggle':

                        let displayToggleInstance = new DisplayToggle(item);

                        displayToggleInstance.init();

                        break;
                    
                    case 'hamburger':

                        let hamburgerInstance = new Hamburger(item);

                        hamburgerInstance.init();

                        break;

                    case 'lazy-load':

                        let lazyLoadInstance = new LazyLoad(item);

                        lazyLoadInstance.init();

                        break;

                    case 'site-nav':

                        let siteNavInstance = new SiteNav(item);

                        siteNavInstance.init();

                        break;
                }
            });
        });
    }
};

// Launch
app.init();
